import { useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useChatStore } from '../stores/chatStore';

export default function ModelSelector() {
    const {
        selectedModel,
        availableModels,
        loadModels,
        setSelectedModel,
    } = useChatStore();

    useEffect(() => {
        loadModels();
    }, [loadModels]);

    return (
        <div className="relative">
            <select
                value={selectedModel}
                onChange={(e) => setSelectedModel(e.target.value)}
                className="appearance-none input py-1.5 pr-8 text-sm cursor-pointer"
            >
                {availableModels.length === 0 ? (
                    <>
                        <option value="gemini-pro">Gemini Pro</option>
                        <option value="gemini-pro-vision">Gemini Pro Vision</option>
                    </>
                ) : (
                    availableModels.map((model) => (
                        <option key={model.model_id} value={model.model_id}>
                            {model.display_name}
                        </option>
                    ))
                )}
            </select>
            <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-dark-400 pointer-events-none" />
        </div>
    );
}
